//VPDNovieOtdeleniyaChleniIliIsklyuchenie
import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { InputNumber, Form, Input } from 'antd';



import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer'



export default function VPDNovieOtdeleniyaChleniIliIsklyuchenie(props) {

    const {zasedanie} = props;
    
    // const [city, setCity] = useState([]);

    // useEffect(() => {
    //     auth.fetch('/api/query/City?s-name').then(res => {
    //         if (res && res.data) {
    //             setCity(res.data);
    //         }
    //     });
    // }, []);

    // const options = city.map(i => (
    //     <Option key={i.ID} value={i.ID}>{i.name}</Option>
    // ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                kvorumDlyaPrinyatiyaResheniya: 50,
                zasedaniePravleniyaFederatsiiID: zasedanie.ID
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedaniePravleniyaFederatsiiID"}
                label={"Заседание правления федерации"}
                rules={[{ required: true, message: 'Укажите заседание правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name={"kvorumDlyaPrinyatiyaResheniya"}
                label={"Кворум для принятия решения"}
                rules={[{ required: true, message: 'Укажите кворум для принятия решения!' }]}
            >
                <InputNumber min={0}
                    max={100}
                    formatter={value => `${value}%`}
                    parser={value => Number.parseFloat(value.replace('%', ''))}
                    precision={2}
                    step={0.05}
                    style={{ width: "50%" }} />
            </Form.Item>
        </Form>
    );
}
